import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { DATE_FORMAT, formatDate, toDateTime } from '@shared/utils/date-time';
import type { DateTime } from 'luxon';

@Pipe({ name: 'appDateWithYear' })
export class DateWithYearPipe implements PipeTransform {
    transform(value: string | DateTime | Date, format?: string): any {
        const instance = toDateTime(value);

        if (instance?.isValid) {
            return instance.toLocal().toFormat(DATE_FORMAT);
        }

        return value;
    }
}
